<template>
    <div v-show="false">
      <img src="/images/public/hotel_list_banner.gif" class="banner-style w-100"/>
    </div>
</template>

<script>
    export default {
        name: 'AdBanner'
    }
</script>
<style scoped lang="scss">
  .banner-style{
    min-width: 1200px;
  }
</style>
